var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M28 23.712h-24c-0.384 0-0.8-0.32-0.992-0.704-0.096-0.416 0-0.896 0.384-1.12 0 0 3.616-2.592 3.616-11.2 0-2.4 0.896-4.704 2.592-6.4s4-2.592 6.4-2.592c2.4 0 4.704 0.896 6.4 2.592s2.592 4 2.592 6.4c0 8.608 3.52 11.104 3.616 11.2 0.384 0.224 0.48 0.704 0.384 1.12-0.192 0.384-0.576 0.704-0.992 0.704zM6.208 21.696h19.488c-1.28-1.792-2.784-5.184-2.784-11.008 0-1.888-0.704-3.584-2.016-4.896-1.28-1.28-3.104-2.080-4.992-2.080s-3.616 0.672-4.896 2.080c-1.312 1.216-2.016 3.008-2.016 4.896 0 5.696-1.504 9.12-2.784 11.008zM16 30.304c-0.608 0-1.312-0.192-1.792-0.512-0.608-0.288-0.992-0.8-1.312-1.28-0.288-0.512-0.096-1.12 0.416-1.408 0.48-0.32 1.088-0.096 1.376 0.384 0.128 0.32 0.416 0.512 0.608 0.608 0.512 0.32 1.216 0.32 1.696 0 0.32-0.096 0.512-0.384 0.608-0.608 0.288-0.48 0.896-0.576 1.408-0.384 0.48 0.288 0.608 0.896 0.384 1.408-0.288 0.576-0.8 0.992-1.28 1.28-0.8 0.416-1.504 0.512-2.112 0.512z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.7c858201a112f3ec5cf7627aaa301b4f.svg";
export { ForwardRef as ReactComponent };